/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { FormattedMessage } from 'react-intl'
import { useFormContext } from '@jalik/react-form'
import FormButton, { FormButtonProps } from './FormButton'

function FormResetButton (props: FormButtonProps) {
  const { disabled, ...others } = props
  const form = useFormContext()
  return (
    <FormButton
      variant="subtle"
      {...others}
      disabled={disabled || !form.modified}
      onClick={() => {
        form.reset()
      }}
    >
      <FormattedMessage
        id="reset"
        defaultMessage="Réinitialiser"
      />
    </FormButton>
  )
}

export default FormResetButton
